import randomElement from "../randomElement";
import randomSubset from "../randomSubset";
import shufflePairs from "../shufflePairs";
import defaultParams from "../defaultParams";

function Matching(minigameData, state){
    var n;
	switch (Number(state.objects.difficulty)) {
        case 0:
		    n = minigameData.variantCount ? minigameData.variantCount[0] : defaultParams.variantCountMatching[0];
		    break;
		case 1:
			n = minigameData.variantCount ? minigameData.variantCount[1] : defaultParams.variantCountMatching[1];
			break;
		default:
            throw new Error(`Difficulty '${state.objects.difficulty}' is not implemented`);
	}
	var array = randomSubset(minigameData.data.things, n);
	var variants = array.map(elem => [randomElement(elem.name), randomElement(elem.meanings)]);
	const form = shufflePairs(variants);
	form.title = minigameData.data.qst;
	return form;
}

export default Matching;
